// extracted by mini-css-extract-plugin
module.exports = {"tablet":"680px","laptop":"980px","desktop":"1180px","card":"highlight_card__bNlIy","label":"highlight_label__OsFqe"};